import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    inverse?: boolean
    className?: string
}

interface LogoProps {
    inverse?: boolean
    className?: string
}

// The mark is an asset tag: the punched hole every device in a rental fleet carries, with the orange "O" of Rent-O-Tech.
export const LogoMark: FC<LogoMarkProps> = ({ inverse = false, className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 44 32'
            aria-hidden='true'
            className={cn('h-8 w-auto shrink-0', className)}
        >
            <path
                d='M12 2h26a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H12L2.8 17.6a2.4 2.4 0 0 1 0-3.2L12 2Z'
                className={inverse ? 'fill-ink-foreground' : 'fill-ink'}
            />
            <circle cx='10' cy='16' r='2.4' className={inverse ? 'fill-ink' : 'fill-background'} />
            <circle cx='28' cy='16' r='6.5' fill='none' strokeWidth='3.5' className='stroke-primary' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ inverse = false, className }): ReactNode => {
    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name} home`}
            className={cn('inline-flex items-center gap-2.5 rounded-md py-1', className)}
        >
            <LogoMark inverse={inverse} />

            <span className={cn('font-heading text-xl font-semibold tracking-tight', inverse ? 'text-ink-foreground' : 'text-foreground')}>
                {siteConfig.name}
            </span>
        </Link>
    )
}
